import React from 'react'
import {ModalBase} from '../../../../../components/Modals/ModalBase'
import DatosProducto from '../DatosProducto'

const ModalEditarProducto = () => {
  return (
    <ModalBase>
      <DatosProducto editar={true} />
    </ModalBase>
  )
}

export default ModalEditarProducto
